import styles from './listPlaceholder.module.scss';

interface ListPlaceholderProps {
    icon?: string;
    title?: string;
    msg?: string;
    extra?: string;
}

export const ListPlaceholder = ({
    icon ="fa-light fa-file-slash",
    title = 'Nothing to show',
    msg,
    extra,
}: ListPlaceholderProps) => {
    return (
        <div className={styles.container}>
            <i className={icon} ></i>
            <h2>{title}</h2>
            <p>{msg}</p>
            {extra && (<p><small>{extra}</small></p>)}
        </div>
    );
};

export default ListPlaceholder;